module.exports = __webpack_public_path__ + "static/img/FQA_2.dff2ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/FQA_2.png
// module id = isP6
// module chunks = 4